
import { defineComponent, inject } from 'vue'
import LineTime from "@/components/widgets/mixed/LineTime.vue"

export default defineComponent({
    props: {
        idacrd: {
            type: null,
            required: true,
            default:0
        }
    },
    components: {LineTime},
    setup() {
        const rowIdObs = inject<any>('rowIdObs')
        const dialogObservation = inject<boolean>('dialogObservation')

        const onClosed = () => {
            rowIdObs.value = 0
        }

        return {
            rowIdObs,
            dialogObservation,

            //methods
            onClosed
        }
        
    },
})
